import React from 'react';

function SavedQuotesPanel({ savedQuotes, onDelete, onLoad }) {
    if (!savedQuotes || savedQuotes.length === 0) {
        return (
            <div className="bg-white rounded-lg shadow p-6 mb-6">
                <p className="text-gray-600">No saved quotes yet</p>
            </div>
        );
    }

    const formatAmount = (quote) => {
        // Safely access nested properties
        try {
            if (quote.quote && quote.quote.summary && quote.quote.summary.finalTotal) {
                return parseFloat(quote.quote.summary.finalTotal).toFixed(2);
            }
            // Fallback to amount if the nested structure isn't available
            if (quote.amount) {
                return parseFloat(quote.amount).toFixed(2);
            }
            return "N/A";
        } catch (error) {
            console.error("Error formatting amount:", error);
            return "N/A";
        }
    };

    return (
        <div className="bg-white rounded-lg shadow p-6 mb-6">
            {savedQuotes.map((quote) => (
                <div 
                    key={quote.id || Math.random().toString()}  // Fallback for missing id
                    className="flex items-center justify-between py-3 border-b last:border-0"
                >
                    <div className="flex-grow">
                        <div className="font-medium">
                            {quote.date ? new Date(quote.date).toLocaleDateString() : 'No date'} - ${formatAmount(quote)}
                        </div>
                        <div className="text-sm text-gray-600">
                            {quote.state ? `${quote.state.region} - ${quote.state.workload}` : 'No details available'}
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <button
                            onClick={() => onLoad(quote)}
                            className="text-blue-600 hover:text-blue-800 px-3 py-1 rounded"
                        >
                            Load
                        </button>
                        <button
                            onClick={() => onDelete(quote.id)}
                            className="text-red-600 hover:text-red-800 px-3 py-1 rounded"
                        >
                            Delete
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default SavedQuotesPanel;
